import React from 'react';

function Process() {
  return (
    <section className="tc-process-style1">
      <div className="container">
        <div className="title mb-100 text-center">
          <h2 className="fsz-45"> Our Work Process </h2>
        </div>
        <div className="content">
          <div className="row">
            <div className="col-lg-5">

              <div className="info">
                <div
                  className="accordion wow fadeInUp slow"
                  id="accordionProcess"
                >
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingOne">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseOne"
                      >
                        <span className="num"> 1 / </span>
                        <h3> Initial Consultation</h3>
                      </button>
                    </div>
                    <div
                      id="collapseOne"
                      className="accordion-collapse collapse show"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                          <ul>
                            <li>    
                          <p><b>Needs Assessment : </b>
                          Gathering information on project goals, budget, and scope.</p>
                          <p><b>Site Visit : </b>
                          Evaluating the site conditions and constraints.</p>
                          </li>
                          <br/>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingTwo">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseTwo"
                      >
                        <span className="num"> 2 / </span>
                        <h3> Concept Development </h3>
                      </button>
                    </div>
                    <div
                      id="collapseTwo"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                        <ul>
                            <li>
                            <p><b>Design Workshops : </b>
                            Collaborative sessions to brainstorm and refine ideas.</p>
                          <p><b>Preliminary Sketches : </b>
                          Creating initial design concepts for client review.</p>
                          </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseThree"
                      >
                        <span className="num"> 3 / </span> <h3> Design Development </h3>
                      </button>
                    </div>
                    <div
                      id="collapseThree"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                        <ul>
                            <li>
                            <p><b>Detailed Drawings : </b>
                            Developing architectural plans, elevations, and sections.</p>
                          <p><b>Material Selection : </b>
                          Choosing finishes, fixtures, and furnishings.</p>
                          </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingFour">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFour"
                      >
                        <span className="num"> 4 / </span> <h3> Documentation </h3>
                      </button>
                    </div>
                    <div
                      id="collapseFour"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                          <ul>
                            <li>
                              <p><b>Construction Documents : </b>
                              Preparing detailed drawings and specifications for bidding and permits.</p>
                          <p><b>Permit Acquisition : </b>
                          Securing necessary approvals from regulatory bodies.</p>
                          </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-item">
                    <div className="accordion-header" id="headingThree">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseFive"
                      >
                        <span className="num"> 5 / </span> <h3> Construction Administration </h3>
                      </button>
                    </div>
                    <div
                      id="collapseFive"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                        <ul>
                            <li>
                            <p><b>Site Visits : </b>
                            Regular inspections to monitor progress and address issues.</p>
                          <p><b>Contractor Liaison : </b>
                          Communicating with builders to ensure compliance with design.</p></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <div className="accordion-header" id="headingseven">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapseseven"
                      >
                        <span className="num"> 6 / </span> <h3> Work Quality </h3>
                      </button>
                    </div>
                    <div
                      id="collapseseven"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                          <ul>
                            <li>
                            <p><b>Commitment to Excellence : </b>
                            We use advanced technology and innovative design principles to create spaces that are both beautiful and functional.</p>

                          <p><b> Design Integrity : </b>
                          We employ cutting-edge tools like Building Information Modeling (BIM) to produce accurate designs, reducing errors and ensuring a smooth construction process. Our designs are crafted with precision to balance aesthetic appeal and practicality.</p>

                          <p><b> Material Selection : </b>
                          We select high-quality materials that meet our standards for durability and sustainability, ensuring that every component of our design is up to par.</p>

                          <p><b> Construction Standards : </b>
                          We collaborate with trusted contractors and builders, conducting regular site inspections to ensure construction aligns with our design specifications and quality standards.</p>

                          <p><b> Attention to Detail : </b>
                          From sketches to final touches, we maintain rigorous attention to detail, conducting multiple review phases to ensure accuracy and consistency.</p>

                          <p><b> Quality Assurance : </b>
                          Our dedicated quality assurance team performs detailed inspections throughout the project to identify and resolve potential issues, ensuring the highest standards are met.</p>

                          <p><b> Personalized Service : </b>
                          We provide a personalized experience by involving clients in every stage of the design and construction process. Our open communication and regular updates keep clients informed and engaged.</p>

                          <p><b> Long-Term Relationships : </b>
                          We build lasting relationships with our clients, many of whom return for future projects or refer us to others. Our focus on delivering value and exceptional service fosters trust and long-term partnerships.</p>
                          </li>
                          
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="accordion-item">
                    <div className="accordion-header" id="headingsix">
                      <button
                        className="accordion-button collapsed"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#collapsesix"
                      >
                        <span className="num"> 7 / </span> <h3> Project Completion </h3>
                      </button>
                    </div>
                    <div
                      id="collapsesix"
                      className="accordion-collapse collapse"
                      data-bs-parent="#accordionProcess"
                    >
                      <div className="accordion-body">
                        <div className="text">
                          <ul>
                            <li>
                            <p><b>Client Walkthrough : </b>
                            Ensuring client satisfaction and addressing any final adjustments.</p>
                          <p><b>Feedback Collection : </b>
                          Gathering client feedback to improve future projects.</p>
                          <p><b>Final Inspection : </b>
                          Conducting a thorough review of the completed work.</p></li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <a
                  href="#"
                  className="butn border rounded-pill mt-80 color-orange1 border-orange1 hover-bg-orange1"
                >
                  <span>
                    Our Projects
                    {/* /innerpages/portfolio */}
                    <i className="small ms-1 ti-arrow-top-right"></i>
                  </span>
                </a>
              </div>

            </div>
            <div className="col-lg-4 offset-lg-2">
              <div className="img wow">
                <img
                  src="/home1/assets/img/process.jpg"
                  alt=""
                  className="img-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <img src="/home1/assets/img/c_line2.png" alt="" className="c-line wow" />
    </section>
  );
}

export default Process;
